module.exports = __webpack_public_path__ + "img/choose-up-Up Cadou STIM.c62f868b.png";